/* Cart drawer: renders /cart.js into sections/gw-cart-drawer.liquid.
   API: window.GWCart.open(cart?), .close(), .refresh(). The header bag opens it; add-to-cart code calls open(). */
(() => {
  const root = document.getElementById('gwCart');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const panel = $('.gw-cd-panel');
  const TH = +root.dataset.threshold || 0;
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let cart = null, lastFocus = null, hideT;

  const VARS = {}; /* product handle -> available variants, for the in-cart option picker */
  let UP = [];
  try { UP = JSON.parse((document.getElementById('gwCdUpData') || {}).textContent || '[]'); } catch (e) { UP = []; }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function money(cents) {
    const fmt = String((window.GW && GW.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    const a = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return Math.round(a).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return a.toFixed(2).replace('.', ',');
      return a.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const icons = () => { if (window.lucide) lucide.createIcons(); };

  async function api(path, body) {
    const r = await fetch(path, body ? { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
    return j;
  }
  async function busy(fn) {
    root.classList.add('busy');
    try { return await fn(); } finally { root.classList.remove('busy'); }
  }

  /* ---------- render ---------- */
  function setBadge(n) {
    document.querySelectorAll('.cart-btn').forEach((btn) => {
      let b = btn.querySelector('.badge');
      if (!b && n > 0) { b = document.createElement('span'); b.className = 'badge'; b.id = 'cartCount'; btn.appendChild(b); }
      if (b) { b.textContent = n; b.hidden = n === 0; }
      btn.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  function lineHTML(it) {
    const variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    const props = Object.entries(it.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_').map(([k, v]) => `${esc(k)}: ${esc(v)}`);
    const discs = (it.line_level_discount_allocations || []).map((d) => `<p class="gw-cd-disc"><i data-lucide="tag"></i>${esc(d.discount_application.title.split(/[:(]/)[0].trim())} · −${money(d.amount)}</p>`).join('');
    const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
    const pct = it.original_line_price > it.final_line_price ? Math.round((1 - it.final_line_price / it.original_line_price) * 100) : 0;
    const vs = VARS[it.handle];
    const picker = vs && vs.length > 1
      ? `<label class="visually-hidden" for="gwV${esc(it.key)}">Change option for ${esc(it.product_title)}</label><select class="gw-cd-vsel" id="gwV${esc(it.key)}" data-var>${vs.map((v) => `<option value="${v.id}"${v.id === it.variant_id ? ' selected' : ''}>${esc(v.title)}</option>`).join('')}</select>`
      : '';
    return `<li class="gw-cd-line" data-key="${esc(it.key)}">
      <a class="gw-cd-img" href="${esc(it.url)}" tabindex="-1" aria-hidden="true">${it.image ? `<img src="${esc(sized(it.image, 200))}" alt="" width="80" height="80" loading="lazy">` : ''}</a>
      <div class="gw-cd-info">
        <a class="gw-cd-t" href="${esc(it.url)}">${esc(it.product_title)}</a>
        ${picker || (variant ? `<p class="gw-cd-v">${esc(variant)}</p>` : '')}${props.length ? `<p class="gw-cd-v">${props.join(' · ')}</p>` : ''}
        ${discs}
        <div class="gw-cd-qty" role="group" aria-label="Quantity for ${esc(it.product_title)}">
          <button type="button" data-qty="-1" aria-label="Decrease quantity"${it.quantity <= 1 ? ' disabled' : ''}><i data-lucide="minus"></i></button>
          <output aria-live="polite">${it.quantity}</output>
          <button type="button" data-qty="1" aria-label="Increase quantity"><i data-lucide="plus"></i></button>
        </div>
      </div>
      <div class="gw-cd-right">
        <button type="button" class="gw-cd-rm" data-rm aria-label="Remove ${esc(it.product_title)}"><i data-lucide="trash-2"></i></button>
        <p class="gw-cd-p">${was}<b>${money(it.final_line_price)}</b>${pct >= 1 ? `<span class="gw-cd-save">Save ${pct}%</span>` : ''}</p>
      </div>
    </li>`;
  }

  function upHTML(p) {
    const v0 = p.variants[0];
    const sel = p.variants.length > 1
      ? `<label class="visually-hidden" for="gwUp${p.id}">Choose an option for ${esc(p.title)}</label><select id="gwUp${p.id}" data-up-sel>${p.variants.map((v) => `<option value="${v.id}" data-price="${v.price}" data-compare="${v.compare}">${esc(v.title)}</option>`).join('')}</select>`
      : `<input type="hidden" data-up-sel value="${v0.id}">`;
    return `<div class="gw-cd-uc" data-pid="${p.id}">
      ${p.img ? `<img src="${esc(p.img)}" alt="" width="64" height="64" loading="lazy">` : '<span></span>'}
      <div>
        <p class="gw-cd-uc-t">${esc(p.title)}</p>
        <p class="gw-cd-uc-p" data-up-price>${priceHTML(v0.price, v0.compare)}${p.note ? ' · ' + esc(p.note) : ''}</p>
        <div class="gw-cd-uc-row">${sel}<button type="button" class="gw-cd-uc-add" data-up-add><i data-lucide="plus"></i>Add</button></div>
      </div>
    </div>`;
  }
  const priceHTML = (price, compare) => `<b>${money(price)}</b>${compare > price ? `<s>${money(compare)}</s><span class="gw-cd-save">Save ${Math.round((1 - price / compare) * 100)}%</span>` : ''}`;

  function render(c) {
    cart = c;
    /* the add-on toggle product (e.g. Shipping Protection) shows only as the switch, never as a line */
    const aoPid = AO ? +AO.dataset.product : 0;
    const lines = c.items.filter((i) => i.product_id !== aoPid);
    if (aoPid && !lines.length && c.items.length) { clearAddon(); return; }
    const n = lines.reduce((a, i) => a + i.quantity, 0), empty = n === 0;
    $('#gwCdCount').textContent = n;
    setBadge(n);

    const ship = $('#gwCdShip');
    if (ship && TH) {
      const tiers = [...root.querySelectorAll('#gwCdTiers li')].map((li) => ({ li, at: +li.dataset.at, label: li.dataset.label })).sort((a, b) => a.at - b.at);
      const max = tiers[tiers.length - 1].at, tot = c.total_price;
      const next = tiers.find((t) => tot < t.at);
      ship.classList.toggle('done', !next);
      ship.classList.toggle('gw-cd-multi', tiers.length > 1);
      tiers.forEach((t) => { t.li.classList.toggle('on', tot >= t.at); t.li.style.left = (t.at / max) * 100 + '%'; });
      const msg = next === tiers[0] || !next ? (next ? root.dataset.todo : root.dataset.done) : `You're [amount] away from ${next.label.toLowerCase()}.`;
      $('#gwCdShipMsg').innerHTML = esc(msg).replace('[amount]', next ? `<b>${money(next.at - tot)}</b>` : '').replace('[reward]', next ? esc(next.label) : '');
      $('#gwCdBar').style.width = Math.min(100, (tot / max) * 100) + '%';
    } else if (ship) ship.hidden = true;

    $('#gwCdLines').innerHTML = lines.map(lineHTML).join('');
    $('#gwCdLines').hidden = empty;
    if (empty) renderContinue();
    if (ship) ship.hidden = empty || !TH;
    $('#gwCdEmpty').hidden = !empty;
    $('#gwCdFoot').hidden = empty;

    const up = $('#gwCdUp');
    if (up) {
      const inCart = new Set(c.items.map((i) => i.product_id));
      const list = UP.filter((p) => p.variants.length && !inCart.has(p.id) && p.id !== aoPid);
      up.hidden = !list.length || empty;
      $('#gwCdUpTrack').innerHTML = list.map(upHTML).join('');
      navState();
    }

    const chips = $('#gwCdChips');
    if (chips) chips.innerHTML = (c.discount_codes || []).map((d) => `<span class="gw-cd-chip${d.applicable ? '' : ' na'}"><i data-lucide="tag"></i>${esc(d.code)}${d.applicable ? '' : ' (not applied)'}<button type="button" data-code-rm="${esc(d.code)}" aria-label="Remove code ${esc(d.code)}"><i data-lucide="x"></i></button></span>`).join('');

    const saved = c.original_total_price - c.total_price;
    $('#gwCdSaved').hidden = saved <= 0 && !(c.discount_codes || []).length;
    $('#gwCdSavedAmt').textContent = saved > 0 ? '−' + money(saved) : '';
    $('#gwCdWas').textContent = saved > 0 ? money(c.original_total_price) : '';
    if (AO) {
      const pid = +AO.dataset.product, want = aoVariant(c);
      $('#gwCdAoIn').checked = c.items.some((i) => i.product_id === pid);
      if (want && want.price) $('#gwCdAoP').textContent = money(want.price);
      if (!empty) syncAddon(c);
    }
    loadVariants(c);
    $('#gwCdTotal').textContent = money(c.total_price);
    $('#gwCdBtnTotal').textContent = money(c.total_price);
    icons();
  }

  /* "Continue where you left off": product pages record themselves; the empty cart shows the last one first */
  const VKEY = 'gwLastViewed';
  if (root.dataset.viewed) { try { localStorage.setItem(VKEY, JSON.stringify(Object.assign(JSON.parse(root.dataset.viewed), { t: Date.now() }))); } catch (e) { /* storage blocked */ } }
  function renderContinue() {
    const li = $('#gwCdCont'); if (!li) return;
    let v = null;
    try { v = JSON.parse(localStorage.getItem(VKEY) || 'null'); } catch (e) { v = null; }
    const fresh = v && v.url && Date.now() - (v.t || 0) < 30 * 864e5;
    li.hidden = !fresh;
    root.querySelectorAll('#gwCdTiles > li:not(#gwCdCont)').forEach((t) => { const a = t.querySelector('a'); t.hidden = !!(fresh && a && new URL(a.href, location.href).pathname === new URL(v.url, location.href).pathname); });
    if (!fresh) return;
    const a = li.querySelector('a');
    a.href = v.url;
    li.querySelector('small').textContent = v.title || '';
    li.querySelector('.gw-cd-tile-img').innerHTML = v.img ? `<img src="${esc(v.img)}" alt="" width="88" height="64" loading="lazy">` : '';
  }

  const AO = $('#gwCdAo');
  let AOV = [], AOB = [];
  if (AO) {
    try { AOV = JSON.parse(AO.dataset.variants || '[]'); } catch (e) { AOV = []; }
    AOB = String(AO.dataset.breaks || '').split(',').map((x) => Math.round(parseFloat(x) * 100)).filter((x) => x > 0);
  }
  /* the add-on variant that matches this cart: one step up for every break the subtotal (without the add-on) reaches */
  function aoVariant(c) {
    if (!AOV.length) return AO ? { id: +AO.dataset.variant, price: 0 } : null;
    const pid = +AO.dataset.product;
    const sub = c.items.filter((i) => i.product_id !== pid).reduce((a, i) => a + i.final_line_price, 0);
    const step = AOB.filter((b) => sub >= b).length;
    return AOV[Math.min(step, AOV.length - 1)];
  }
  let aoSyncing = false;
  async function syncAddon(c) {
    if (!AO || aoSyncing) return;
    const pid = +AO.dataset.product, want = aoVariant(c);
    const mine = c.items.filter((i) => i.product_id === pid);
    if (!mine.length || !want) return;
    if (mine.length === 1 && mine[0].variant_id === want.id && mine[0].quantity === 1) return;
    aoSyncing = true;
    const updates = {};
    mine.forEach((i) => { updates[i.key] = 0; });
    try { await api('/cart/update.js', { updates }); await api('/cart/add.js', { items: [{ id: want.id, quantity: 1 }] }); render(await api('/cart.js')); }
    catch (e) { /* keep the current line */ } finally { aoSyncing = false; }
  }
  function loadVariants(c) {
    const need = [...new Set(c.items.filter((i) => !i.product_has_only_default_variant && !(i.handle in VARS)).map((i) => i.handle))];
    if (!need.length) return;
    need.forEach((h) => { VARS[h] = null; });
    Promise.all(need.map((h) => fetch('/products/' + h + '.js').then((r) => r.json()).then((p) => { VARS[h] = p.variants.filter((v) => v.available).map((v) => ({ id: v.id, title: v.title })); }).catch(() => { VARS[h] = []; })))
      .then(() => { if (cart) render(cart); });
  }

  async function clearAddon() {
    const updates = {};
    cart.items.forEach((i) => { updates[i.key] = 0; });
    try { render(await api('/cart/update.js', { updates })); } catch (e) { /* ignore */ }
  }

  async function refresh() { render(await api('/cart.js')); return cart; }

  /* ---------- open / close ---------- */
  async function open(c) {
    clearTimeout(hideT);
    if (c && c.items) render(c);
    if (root.hidden) { lastFocus = document.activeElement; root.hidden = false; void root.offsetWidth; }
    root.classList.add('open');
    document.documentElement.classList.add('gw-cd-lock');
    panel.focus({ preventScroll: true });
    if (!c) { try { await busy(refresh); } catch (e) { /* keep the last render */ } }
  }
  function close() {
    root.classList.remove('open');
    document.documentElement.classList.remove('gw-cd-lock');
    hideT = setTimeout(() => { root.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- actions ---------- */
  async function change(key, quantity) {
    const li = root.querySelector(`.gw-cd-line[data-key="${CSS.escape(key)}"]`);
    try { await busy(async () => render(await api('/cart/change.js', { id: key, quantity }))); }
    catch (e) { if (li) { const p = document.createElement('p'); p.className = 'gw-cd-err'; p.textContent = e.message; li.appendChild(p); } }
  }
  async function setCodes(codes) { return api('/cart/update.js', { discount: codes.join(',') }); }

  root.addEventListener('click', async (e) => {
    const t = e.target;
    if (t.closest('[data-cd-close]')) return close();
    const q = t.closest('[data-qty]'), rm = t.closest('[data-rm]');
    if (q || rm) {
      const li = t.closest('.gw-cd-line'), it = cart.items.find((i) => i.key === li.dataset.key);
      return change(it.key, rm ? 0 : Math.max(0, it.quantity + +q.dataset.qty));
    }
    const nav = t.closest('[data-up]');
    if (nav) { const tr = $('#gwCdUpTrack'); tr.scrollBy({ left: +nav.dataset.up * (tr.clientWidth - 28), behavior: 'smooth' }); return; }
    const add = t.closest('[data-up-add]');
    if (add) {
      const card = add.closest('.gw-cd-uc'), id = +card.querySelector('[data-up-sel]').value;
      add.disabled = true;
      try { await busy(async () => { await api('/cart/add.js', { items: [{ id, quantity: 1 }] }); await refresh(); }); }
      catch (err) { add.disabled = false; add.textContent = err.message; }
      return;
    }
    const crm = t.closest('[data-code-rm]');
    if (crm) {
      const keep = (cart.discount_codes || []).map((d) => d.code).filter((c) => c !== crm.dataset.codeRm);
      try { await busy(async () => render(await setCodes(keep))); } catch (err) { /* ignore */ }
    }
  });

  root.addEventListener('change', async (e) => {
    const vsel = e.target.closest('select[data-var]');
    if (vsel) {
      const li = vsel.closest('.gw-cd-line'), it = cart.items.find((i) => i.key === li.dataset.key), id = +vsel.value;
      if (!it || id === it.variant_id) return;
      try { await busy(async () => { await api('/cart/add.js', { items: [{ id, quantity: it.quantity, properties: it.properties || {} }] }); render(await api('/cart/change.js', { id: it.key, quantity: 0 })); }); }
      catch (err) { vsel.value = it.variant_id; }
      return;
    }
    if (e.target.id === 'gwCdAoIn') {
      const want = aoVariant(cart), id = want ? want.id : +AO.dataset.variant, on = e.target.checked;
      try {
        await busy(async () => {
          if (on) { await api('/cart/add.js', { items: [{ id, quantity: 1 }] }); await refresh(); }
          else { const pid = +AO.dataset.product, updates = {}; cart.items.filter((i) => i.product_id === pid).forEach((i) => { updates[i.key] = 0; }); render(await api('/cart/update.js', { updates })); }
        });
      } catch (err) { e.target.checked = !on; }
      return;
    }
    const s = e.target.closest('select[data-up-sel]');
    if (!s) return;
    const o = s.selectedOptions[0];
    const p = s.closest('.gw-cd-uc').querySelector('[data-up-price]');
    const note = p.textContent.split(' · ').slice(1).join(' · ');
    p.innerHTML = priceHTML(+o.dataset.price, +o.dataset.compare) + (note ? ' · ' + esc(note) : '');
  });

  const form = $('#gwCdCodeForm');
  if (form) form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const inp = $('#gwCdCodeIn'), err = $('#gwCdCodeErr'), code = inp.value.trim();
    err.hidden = true;
    if (!code) return;
    const existing = (cart.discount_codes || []).map((d) => d.code);
    if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) { inp.value = ''; return; }
    try {
      await busy(async () => {
        const c = await setCodes(existing.concat(code));
        const hit = (c.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (!hit || !hit.applicable) {
          render(await setCodes(existing));
          err.textContent = `“${code}” can't be applied to this cart.`;
          err.hidden = false;
        } else { render(c); inp.value = ''; }
      });
    } catch (ex) { err.textContent = ex.message; err.hidden = false; }
  });

  /* upsell arrows */
  function navState() {
    const tr = $('#gwCdUpTrack'); if (!tr) return;
    const [prev, next] = root.querySelectorAll('[data-up]');
    const many = tr.children.length > 1;
    root.querySelector('.gw-cd-up-nav').hidden = !many;
    prev.disabled = tr.scrollLeft < 4;
    next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
  }
  const track = $('#gwCdUpTrack');
  if (track) track.addEventListener('scroll', () => requestAnimationFrame(navState), { passive: true });

  /* keyboard: Escape closes, Tab stays inside */
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const f = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select,summary,[tabindex]:not([tabindex="-1"])')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* header bag opens the drawer (the link still works without JS) */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.cart-btn, a[href="/cart"][data-cart-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh().catch(() => {}); });

  window.GWCart = { open, close, refresh };
})();
